export default {
  searchUserPlaceholder: 'Name or email',
  searchUsersMatching: '0 users matched your search. Check that you have spelled correctly, maybe you can add a last name? | 1 user matched your search. | {userCount} users matched your search.',
  selectAll: 'Select the entire hunting team',
  deselectAll: 'Deselect the entire hunting team'
}
